// Shared lazy import factories so React.lazy() and prefetch share the same
// module promise (same chunk, same cache entry).
export const dashboardImport = () => import("@/pages/Dashboard");
export const chatImport = () => import("@/pages/Chat");
export const calendarImport = () => import("@/pages/CalendarPage");
export const prospectsImport = () => import("@/pages/Prospects");
export const emailsImport = () => import("@/pages/EmailsPage");
export const checklistsImport = () => import("@/pages/ChecklistsPage");
export const notificationsImport = () => import("@/pages/Notifications");
export const wellbeingImport = () => import("@/pages/WellbeingPage");
export const eventsImport = () => import("@/pages/EventsPage");
export const contentImport = () => import("@/pages/Content");
export const contactsImport = () => import("@/pages/Contacts");
export const searchHubImport = () => import("@/pages/SearchHub");
export const settingsImport = () => import("@/pages/SettingsPage");

export type PageImport = () => Promise<unknown>;

const ROUTE_IMPORTS: Record<string, PageImport> = {
  "/dashboard": dashboardImport,
  "/chat": chatImport,
  "/calendar": calendarImport,
  "/prospects": prospectsImport,
  "/emails": emailsImport,
  "/checklists": checklistsImport,
  "/notifications": notificationsImport,
  "/wellbeing": wellbeingImport,
  "/events": eventsImport,
  "/content": contentImport,
  "/contacts": contactsImport,
  "/search": searchHubImport,
  "/settings": settingsImport,
};

const prefetched = new Set<PageImport>();

export function prefetchPage(fn: PageImport) {
  if (prefetched.has(fn)) return;
  prefetched.add(fn);
  // Fire and forget; ignore failures (network or HMR).
  fn().catch(() => prefetched.delete(fn));
}

export function prefetchRoute(path: string) {
  // Tolerate paths with query/hash.
  const clean = path.split("?")[0].split("#")[0];
  const fn = ROUTE_IMPORTS[clean];
  if (fn) prefetchPage(fn);
}
